import { Tabs as MantineTabs } from '@mantine/core';
import React from 'react';

import styles from './DailyTab.module.css';

const LBDailyTabList = React.forwardRef<
  React.ElementRef<typeof MantineTabs.List>,
  React.ComponentPropsWithoutRef<typeof MantineTabs.List>
>(({ children, ...props }, ref) => (
  <MantineTabs.List className={styles.list} {...props} ref={ref}>
    {children}
  </MantineTabs.List>
));

const LBDailyTab = React.forwardRef<
  React.ElementRef<typeof MantineTabs.Tab>,
  React.ComponentPropsWithoutRef<typeof MantineTabs.Tab>
>(({ children, ...props }, ref) => (
  <MantineTabs.Tab className={styles.tab} {...props} ref={ref}>
    {children}
  </MantineTabs.Tab>
));

const LBDailyPanel = React.forwardRef<
  React.ElementRef<typeof MantineTabs.Panel>,
  React.ComponentPropsWithoutRef<typeof MantineTabs.Panel>
>(({ children, ...props }, ref) => (
  <MantineTabs.Panel {...props} ref={ref}>
    {children}
  </MantineTabs.Panel>
));

export const LBDailyTabs = {
  List: LBDailyTabList,
  Tab: LBDailyTab,
  Panel: LBDailyPanel
};
